module.exports = require('./helpers/bundle-url').getBundleURL('fjrTL') + "logo-dark.eefe0b7f.svg";